import React from 'react';
import { Multiselect } from 'AWS-UI-Components-React';

/*
TODO: Delete this after deprecating old accuracy_table.
 */
export class BaselineColumnButton extends React.Component {
  pullColumnSetsFromJson = (sets) => {
    this.dropdownOptions = [];
    for (let child of sets) {
      let dropdownItem = {};
      dropdownItem['label'] = child['label'];
      dropdownItem['value'] = child['id'];
      dropdownItem['columns'] = child['columns'];
      this.dropdownOptions.push(dropdownItem);
    }
    return this.dropdownOptions;
  };

  render() {
    return (
      <div id="benchmark-filter">
        <Multiselect
          data-cy="benchmark-selection"
          options={this.pullColumnSetsFromJson(this.props.sets)}
          placeholder={this.props.text}
          onChange={this.props.onChange}
          selectedOptions={this.props.selected}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/baseline_column_button.jsx